import React, { Component } from "react";

import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Container, Divider,Box } from "@mui/material";
import { Bar, BarChart, Cell, XAxis, ResponsiveContainer,LabelList } from "recharts";
import wyzrTheme from "../styles/customTheme";

import LoaderCard from "../components/ui-components/LoaderCard";
import axios from "axios";
import { getURLBase } from "../utils/helperFns";

export class SpendingBudget extends Component {
  constructor(props) {
    super(props);
    this.url = getURLBase(true) + "/budgetplan"; 
    this.state = {
      isReady: false,
      activeIndex: 0,
      graphData: [],
    };
  }

  componentDidMount() {
    if (!this.state.isReady) {
      axios.post(this.url, { gid: this.props.gid }).then(
        (response) => {
          var dateRange, dateRangeArr,todaysDate;
          response.data.body.data.forEach(el => {
            el.inFuture = false;
            el.unit = "£ "+ el.amount;
            dateRange = el.name;
            dateRangeArr = dateRange.split("-");
            todaysDate = new Date().getDate();
            dateRangeArr.forEach(x => {
              if(parseInt(x) > todaysDate) el.inFuture = true;
            });
          });
      
          this.setState({ isReady: true, graphData: response.data.body.data});
        }
      )
    }

  }

  handleClick = (data, index) => {
    this.props.barClickHandler(data, index);
    this.setState({
      activeIndex: index,
    });
  }

  CustomizedLabel = ({ x, y, value, width }) => {
    return (
      <>
        <text x={x + width / 2} y={y-5} fontSize="0.9rem" fontWeight={700} dy={value > 0 ? "-0.5em" : "1em"} textAnchor="middle">£{' '}{Math.round(value)}</text>
      </>
    )
  };

  render() {
   
    const WidgetData = () => (
      this.state.isReady ?
        <Card className="widgetCard cardShadow">
           <Typography variant="h4" sx={{ fontWeight: 700 }} align="center" >
              Spending Budget
            </Typography>
            <Typography
              variant="subtitle1"
              color="text.secondary"
              fontWeight="600"
              align="center"
              gutterBottom
            >
              This month
            </Typography>
            <Divider light />
          <CardContent textAlign="center">
           
         <Box maxWidth={500} marginX="auto"> 
              <ResponsiveContainer width="100%" height={200}>
              <BarChart width="100%" height="100%" data={this.state.graphData}>
                <XAxis dataKey="name" />
                <Bar
                  dataKey="amount"
                  fill="#8884d8"
                  onClick={this.handleClick}
                  barSize={30}
                  //label={this.CustomizedLabel}
                  radius={[10, 10, 0, 0]}
                >
                  <LabelList  width={50} dataKey="unit" position="top" offset={5} style={{ fontSize: "0.9rem", fontWeight: 700, fill: "#000" }} />
                  {this.state.graphData.map((entry, index) => (
                    <Cell
                      cursor="pointer"
                      fill={index === this.state.activeIndex ? wyzrTheme.palette.primary.light : entry.inFuture ? wyzrTheme.palette.grey[400]: wyzrTheme.palette.error.light}
                      key={`cell-${index}`}
                    />
                  ))}
                </Bar>
              </BarChart>
              </ResponsiveContainer>
              </Box>              
          </CardContent>
        </Card> : null
    );

    if (!this.state.graphData) return <LoaderCard title={"Loading Data"} />;
    else {
      return <WidgetData />;
    } 
  }
}

export default SpendingBudget;
